import { FeatureCollection } from "geojson";
import { Geo } from "@rogoag/geo";
import { ProagricaTypes } from "../types/ProagricaTypes";

export namespace ProagricaGeoFetcher {
	export function getBoundaryGeoJSON(records: ProagricaTypes.BoundaryRecord[]) {
		const polygons: FeatureCollection[] = [];
		for (const record of records) {
			const geoJSON = Geo.toGeoJSON(record.WKT);
			for (const feature of geoJSON.features) {
				feature.properties = { measure: record.Measure.Value };
			}
			polygons.push(geoJSON);
		}
		return Geo.merge(polygons);
	}

	export function getZoneOrPointsGeoJSON(fieldSamplingItem: ProagricaTypes.SamplingActivity): FeatureCollection {
		const geoJSONObjects = fieldSamplingItem.SoilSamplingRecords.map((record) => {
			const geoJSON = Geo.toGeoJSON(record.WKT);
			if (geoJSON.features.length > 0) {
				geoJSON.features[0].properties = {
					SampleID: record.SoilSamplingData?.SampleID?.Value ?? 0,
					ApplicationDate: fieldSamplingItem.ApplicationDate,
					Depth: record.SoilSamplingData?.TopsoilSamplingDepth?.Depth?.Value ?? 0,
					Units: (record.SoilSamplingData?.TopsoilSamplingDepth?.UnitID?.Value ?? 0) === 52 ? "in" : "",
				};
			}
			return geoJSON;
		});

		return Geo.merge(geoJSONObjects);
	}
}
